import UpNextVideo from './UpNextVideo';

export default UpNextVideo;
